// removed by extract-text-webpack-plugin
module.exports = {"home":"home__2uEtk","content":"content__2WCkd","options":"options__2SxD0","option-base":"option-base__1g5Ci","name":"name__2kQc9","details":"details__3td1K","emoji":"emoji__qjwv4"};


//////////////////
// WEBPACK FOOTER
// ./routes/demo/demoList/style.css
// module id = 1Bdh
// module chunks = 14